import { html, nothing } from '@shared/utils/rendering/html';
import NavTab from '@shared/components/navigation/navigation-tabs/nav-tab';
import NavigationTabs from '@shared/components/navigation/navigation-tabs';
import CollapseSection from '@shared/components/sections/collapse-section';

import { RdarrReimaginedTabsConfig } from '../../../configs/routes/dashboard-tabs/dashboard-tabs.config';
import StaticDocumentation from './static-documentation';
import { useState } from 'preact/hooks';
import Frameworks from './frameworks';
import { RdarrReimaginedTabs } from '../../../constants/routing/tabs.constants';
import rdarrImage1 from '@assets/RDARR-1.png';
import rdarrImage2 from '@assets/RDARR-2.png';
import GroupCommittees from './group-committees';
import Components from './components';

const RdarrReImagined = () => {
    const [activeTab, setActiveTab] = useState(RdarrReimaginedTabsConfig.at(0));

    return html`
        <${StaticDocumentation} />
        <${NavigationTabs}>
            ${RdarrReimaginedTabsConfig.map(
                (tab) =>
                    html`<${NavTab}
                        activeTab=${activeTab}
                        setActiveTab=${setActiveTab}
                        tabDetails=${tab}
                    />`
            )}
        </${NavigationTabs}>

        <div class="card">
            ${
                activeTab.id == RdarrReimaginedTabs.rdarrFrameworks
                    ? html`<${Frameworks} />`
                    : nothing
            }
            ${
                activeTab.id == RdarrReimaginedTabs.groupCommittees
                    ? html`<${GroupCommittees} />`
                    : nothing
            }
            ${activeTab.id == RdarrReimaginedTabs.components ? html`<${Components} />` : nothing}
        </div>

        <${CollapseSection} id="policy-standards" title=${{
            text: 'Policy & Standards & Risk Management Framework',
        }}>

        <div class="flex-wrap-2">
            <img
                class="flex-item"
                src=${rdarrImage1}
                loading="lazy"
                decoding="async"
                alt="RDARR Framework Diagram 1"
            />
            <img
                class="flex-item"
                src=${rdarrImage2}
                loading="lazy"
                decoding="async"
                alt="RDARR Framework Diagram 2"
            />
        </div>


        </${CollapseSection}>
    `;
};

export default RdarrReImagined;
